import readOnly from 'helpers/readOnly';

import Input from './Input/Input';
const ReadOnlyInput = readOnly(Input);

import TextArea from './TextArea/TextArea';
const ReadOnlyTextArea = readOnly(TextArea);

export {ReadOnlyInput as Input, ReadOnlyTextArea as TextArea};
